module.exports = __webpack_public_path__ + "img/logo.31fb6ba2.png";